import { Norm } from "graphql/types"

export const getNormName = (norm: Norm) => {
  const parts = [norm.name]

  if (norm.revision && norm.revision.trim()) parts.push(norm.revision)
  if (norm.date && norm.date.trim()) parts.push(norm.date)

  return parts.join(" ")
}
